import { automatedActivityTypes } from '../activityTypes.utils';
export const getAuthorName = (entry) => {
    var _a, _b, _c, _d;
    return ((_a = entry.author) === null || _a === void 0 ? void 0 : _a.name) ||
        ((_b = entry.author) === null || _b === void 0 ? void 0 : _b.email) ||
        ((_c = entry.author) === null || _c === void 0 ? void 0 : _c.phone_number) ||
        ((_d = entry.author) === null || _d === void 0 ? void 0 : _d.id) ||
        '';
};
export const isAutomaticEvent = (entry) => automatedActivityTypes.includes(entry.activity_type);
